//? PLUGINS //
import DeleteIcon from "@mui/icons-material/Delete";
import {
    Button,
    List,
} from "@mui/material";
import { Box, Theme } from "@mui/system";
import React, {
    CSSProperties,
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
} from "react";
import { useDropzone } from "react-dropzone";
import { IconContext } from "react-icons";
import {
    AiFillFileImage,
    AiFillFilePdf,
    AiFillFileText,
    AiFillFileUnknown,
    AiFillFileWord,
    AiFillFileZip,
    AiOutlineLink,
    AiOutlineUpload,
} from "react-icons/ai";
import { MdCloudUpload } from "react-icons/md";
import { useParams } from "react-router-dom";
import * as UUID from "uuid";

//? SERVICES //
import * as applicationService from "services/application-service";
import * as attachmentService from "services/attachment-service";
import * as certifcateService from "services/certificate-service";
import * as connectiveService from "services/connective-service";



import { useTranslation } from "react-i18next";
import { AxiosRequestConfig, AxiosError } from "axios";
import InfoFileRow from "./fileInfoRow";

//! ------------------------------------------------------------------------------------ //

interface IProps {
    showMessage: MessageBox;
    setFilesUploaded: Dispatch<SetStateAction<boolean>>;
    fileUploads?: FileUploadType[];
    clickable?: boolean;
    disable?: boolean;
    isCorrespondentie?: boolean;
    titleStyle?: CSSProperties;
    completionHash?: string;
    isCertificates?: boolean;
    backgroundColor?: string;
    title?: string;
    isStep5?: boolean;
    isVertr?: boolean;
    textUpload?: string;
    getFilesChanged?: (value: any, finished: boolean) => void;
    isSignedFile?: boolean;
    detailPage?: boolean;
    disableDelete?: boolean;
    getFiles?: (files: FileUploadType[]) => void;
    fileType?: number;
  allowedFiles?: string[];
}

export type FileUploadType = {
    id: string;
    dbId?: string;
    file: File;
    progress: number;
    extension?: string;
    disable?: boolean;
    type?: string;
    preview?: boolean;
};

const FileUpload = (props: IProps) => {
    const { t } = useTranslation();
    const {
        showMessage,
        setFilesUploaded,
        isStep5,
        isVertr,
        clickable,
        disable,
        isCorrespondentie,
        completionHash,
        isCertificates,
        backgroundColor = "#fafafa",
        title = t('requestIndividual.step4.title'),
        textUpload = t("requestIndividual.step4.uploadText"),
        isSignedFile,
        allowedFiles,
        detailPage = false,
        getFiles,
        disableDelete = false,
        fileType
    } = props;
  const { applicationId, certificateId } = useParams();
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [fileUploads, setFileUploads] = useState<FileUploadType[]>(props.fileUploads !== undefined ? props.fileUploads : []);
  const allowedFilesExtensionsList = (allowedFiles && allowedFiles.length >= 1) ? allowedFiles : [
    "pdf",
    "doc",
    "docx",
    "jpeg",
    "jpg",
    "png",
  ];

    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");


    const showError = (message: string) => {
        setErrorMessage(message);
        setShowErrorMessage(true);
    };


    function getExtension(file: File): string {
        return file.name.split(".").pop() || "";
    }

    async function onDrop(acceptedAttachments: File[]) {
        if (!disable) {
            await test(acceptedAttachments);
        }
    }

    async function test(acceptedAttachments: File[]) {
        let filtered = acceptedAttachments.filter((file) =>
            allowedFilesExtensionsList.includes(getExtension(file).toLowerCase())
        );

        let notAllowed = acceptedAttachments.filter(
            (file) => !allowedFilesExtensionsList.includes(getExtension(file).toLowerCase())
        );

        notAllowed.forEach((file) => {
            showMessage(
                `${t("errors.extension.part1")} (${file.name}) ${t(
                    "errors.extension.part2"
                )} [${getExtension(file)}] ${t("errors.extension.part3")}`,
                "error",
                2000
            );
        });

        var temp = fileUploads.concat(
            filtered.map((file) => ({
                id: UUID.v4(),
                file: file,
                progress: 0,
                extension: file.name.split(".").pop() || "",
            })));

        // setFileUploads((prevFiles) => [
        //   ...prevFiles,
        //   ...filtered.map((file) => ({
        //     id: UUID.v4(),
        //     file: file,
        //     progress: 0,
        //     extension: file.name.split(".").pop() || "",
        //   })),
        // ]);

        setFileUploads(temp);
        if (temp.length > 0)
            setUploadFiles(true);
    }

    const [uploadFiles, setUploadFiles] = useState<boolean>(false);

    useEffect(() => {
        if (uploadFiles && !disable) {
            setUploadFiles(false);
            handleFileUpload();
        }
    }, [uploadFiles]);

    const handleFileUpload = async () => {
        setShowErrorMessage(false);
        if (disable) return;
        var successUploadAny = false;
        var errorUpload: FileUploadType[] = [];

        console.log(fileUploads)
        if (fileUploads.filter(obj => obj !== null && obj.progress != 100).length > 0) {
            const uploadRequests = fileUploads.filter(obj => obj !== null || obj !== undefined).map(async (fileUpload) => {
                if (fileUpload.progress === 100) return null;
                const formData = new FormData();
                formData.append("file", fileUpload.file);
                formData.append("progressId", fileUpload.id);
                if (clickable && !isCorrespondentie) formData.append('isEditable', 'true')
                if (completionHash) formData.append('completionHash', completionHash);
                if (isStep5 && !isVertr) formData.append('isManuallySigned', 'true');
                if (isVertr && isStep5) formData.append('isVertrouwelijk', 'true');
                if (isCorrespondentie) formData.append('isCorrespondentie', 'true');
                if (fileType) formData.append('fileType', fileType.toString());

                const config: AxiosRequestConfig<FormData> = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress(event) {
                        const progress = Math.round((event.loaded * 100) / event.total);
                        setFileUploads((prevFileUploads) =>
                            prevFileUploads.map((prevFileUpload) =>
                                prevFileUpload.id === fileUpload.id
                                    ? {
                                        ...prevFileUpload,
                                        progress: progress,
                                    }
                                    : {...prevFileUpload, progress: progress}
                            )
                        );
                    },
                };
                if (isCertificates && !isSignedFile) {
                    return await applicationService.uploadAttachmentCertificateAsync(formData, certificateId as string, config).then((file) => {
                        if (props.getFilesChanged) {
                            props.getFilesChanged(file, true);
                        }
                        successUploadAny = true;
                        return file;
                    }).catch((error: AxiosError<Error>) => {
                        errorUpload.push(fileUpload);
                        showMessage(`${t("errors.upload")} ${fileUpload.file.name}`, "error", 3000);
                    });
        
                } else if (isCertificates && isSignedFile) {
                    await certifcateService.postSignedFile(formData, certificateId as string, config).then((file: any) => {
                        if (props.getFilesChanged) {
                            props.getFilesChanged(file, true);
                        }
                        setFileUploads((prevFileUploads) =>
                            prevFileUploads.map((prevFileUpload) => {
                                if (prevFileUpload.id === fileUpload.id) {
                                    return { ...prevFileUpload, dbId: file.id, progress: 100 }
                                }
                                return {...prevFileUpload, progress: 100};
                            })
                        );
                    }).catch((error: AxiosError<Error>) => {
                        errorUpload.push(fileUpload);
                        showMessage(`${t("errors.upload")} ${fileUpload.file.name}`, "error", 3000);
                    });
                } else if (!isCertificates && isSignedFile) {
                    return await applicationService.uploadSingedFile(formData, applicationId as string, config).then((file) => {
                        if (props.getFilesChanged) {
                            props.getFilesChanged(file, true);
                        }
                        successUploadAny = true;
                        return file;
                    }).catch((error: AxiosError<Error>) => {
                        errorUpload.push(fileUpload);
                        showMessage(`${t("errors.upload")} ${fileUpload.file.name}`, "error", 3000);
                        return null;
                    });
                } else {
                    return await applicationService.uploadAttachmentAsync(formData, applicationId as string, config).then((file: GetAttachmentResponse) => {
                        if (props.getFilesChanged) {
                            props.getFilesChanged(file, true);
                        }
                        setFileUploads((prevFileUploads) =>
                            prevFileUploads.map((prevFileUpload) => {
                                if (prevFileUpload.id === fileUpload.id) {
                                    return { ...prevFileUpload, dbId: file.id, progress: 100 }
                                }
                                return {...prevFileUpload, progress: 100};
                            })
                        );
                        successUploadAny = true;
                        return file;
                    }).catch((error: AxiosError<Error>) => {
                        errorUpload.push(fileUpload);
                        showMessage(`${t("errors.upload")} ${fileUpload.file.name}`, "error", 3000);
                        return null;
                    });
                }
            });


            try {
                await Promise.all(uploadRequests).then((resp) => {
                    console.log(resp, successUploadAny)
                    if (successUploadAny) {
                        showMessage(t("success.upload"), "success", 2000);
                        setFilesUploaded(true);
                        const newFiles = fileUploads.map((prevFileUpload) => {
                            const newFile = resp.find((file) => (file && (file as GetAttachmentResponse).progressId === prevFileUpload.id)) as GetAttachmentResponse;
                            if (newFile) {
                                return { ...prevFileUpload, dbId: newFile.id, type: newFile.fileType, progress: 100 }
                            }
                            return {...prevFileUpload, progress: 100};
                        });
                        if (getFiles) getFiles(newFiles)
                        // getFiles && getFiles(fileUploads);
                        // console.log('success', fileUploads)
                    }

                    if (errorUpload.length > 0) {
                        errorUpload.forEach(element => {
                            const filteredFiles = fileUploads.filter((file) => file.id !== element.id);
                            // The SetFilesUploads is needed for step 4, otherwise the files are not updated
                            setFileUploads(filteredFiles);
                            getFiles && getFiles(filteredFiles);
                        });
                    }
                });
            } catch (e) {
                showError(`${t("requestIndividual.step4.uploadError")}`);
            }
        }
    };

    const uploadBoxStyle = () => {
        return {
            my: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderWidth: 2,
            borderRadius: 2,
            borderStyle: "dashed",
            borderColor: "#bdbdbd",
            backgroundColor: backgroundColor,
            padding: (theme: Theme) => theme.spacing(2),
            color: "#bdbdbd",
            outline: "none",
            transition: "border .24s ease-in-out",
            cursor: "pointer",
            "&:hover": {
                borderColor: clickable ? "black" : "#2196f3",
                color: clickable ? "black" : "#2196f3",
            },
        };
    };
    const Template = (color: string, element: React.ElementType): JSX.Element => {
        return (
            <IconContext.Provider
                value={{
                    size: "2rem",
                    style: { margin: "0 1rem", alignSelf: 'center' },
                    color: color,
                }}
            >
                {<Box component={element} />}
            </IconContext.Provider>
        );
    };

    const handleDownload = (file: FileUploadType): void => {
        const download = (res: Blob) => {
            if (res === undefined) return;
            var fileUrl = URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = `${file.file.name}`;
            link.click();
        }

        if (file.preview) {
            if (file.type === 'Attest' && (file.dbId === undefined || file.dbId === null || file.dbId === "")) {
                certifcateService.getSignedFile(file.id).then((res: Blob) => {
                    if (res !== undefined) {
                        var fileUrl = URL.createObjectURL(res);
                        var fileName = file.file.name;
                        const link = document.createElement("a");
                        link.href = fileUrl;
                        link.download = fileName;
                        link.click();
                    }
                });
            }
            else {
                connectiveService.getPackagePreviewLink(file.dbId as string, file.type as string)
                .then((res) => {
                    if (res.startsWith("No Preview available for given package")) {
                        applicationService.getSignedFile(applicationId as string).then(download);
                    }
                    else if (res.startsWith("PackageId=")) {
                        attachmentService.getAttachment(res.split('PackageId=')[1]).then(download);
                    }
                    else {
                        window.open(res, '_blank', 'noreferrer');
                    }
                });
            }
        }
        else {
            if (clickable && file.dbId !== undefined) {
                switch (file.type) {
                    case 'Aanvraagformulier':
                        applicationService.getSignedFile(applicationId as string).then(download);
                        break;
                    case 'Attest':
                        certifcateService.getSignedFile(certificateId as string).then(download);
                        break;
                    default:
                        attachmentService.getAttachment(file.dbId).then(download)
                        break;
                }
            }
        }
    }

    const handleFileType = (fileUpload: FileUploadType): JSX.Element => {
        switch (fileUpload.file.type) {
            case "preview":
                if (fileUpload.dbId === undefined || fileUpload.dbId === null || fileUpload.dbId === "") {
                    return Template("red", AiFillFilePdf);
                }
                return Template("black", AiOutlineLink);

            case "application/pdf":
                return Template("red", AiFillFilePdf);

            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return Template("blue", AiFillFileWord);

            case "application/msword":
                return Template("blue", AiFillFileWord);

            case "image/jpeg":
            case "image/jpg":
                return Template("grey", AiFillFileImage);

            case "image/png":
                return Template("orange", AiFillFileImage);

            default:
                return Template("grey", AiFillFileImage);
        }
    };

    return (
        <Box>
            <h2 style={props.titleStyle}>{title}</h2>
            {showErrorMessage &&
                <Box sx={{ width: "100%", textAlign: "center", marginBottom: "10px" }}>
                    <Box color="error.main">
                        {errorMessage}
                        <Box sx={{ marginTop: "5px" }}>
                            <Button color="error" variant="outlined" onClick={() => handleFileUpload()}>{t("buttons.tryAgain")}</Button>
                        </Box>
                    </Box>
                </Box>
            }
            <Box>
                {!disable &&
                    (!detailPage &&
                        <Box sx={uploadBoxStyle} {...getRootProps({
                            onClick: event => {
                                if (disable) event.stopPropagation();
                            }
                        })}>
                            <input {...getInputProps()} />
                            <IconContext.Provider value={{ size: clickable || isStep5 ? "2rem" : "10rem" }}>
                                <MdCloudUpload />
                            </IconContext.Provider>
                            <Box sx={{textAlign: 'center'}}>{textUpload}</Box>
                        </Box>
                    )
                }

                {fileUploads.length > 0 && (
                    <Box>
                        <List
                            sx={{
                                boxShadow: "none",
                                border: "1px solid rgba(189, 189, 189,0.3)",
                                borderRadius: "10px",
                                mb: "20px",
                                p: 0,
                            }}
                        >
                            {fileUploads.map((fileUpload, index, allFiles) => {
                                const Icon = () => handleFileType(fileUpload);
                                return (
                                    <InfoFileRow
                                        key={index}
                                        index={index}
                                        fileUpload={fileUpload}
                                        icon={Icon}
                                        total={allFiles.length}
                                        updateState={setFileUploads}
                                        setFilesUploaded={setFilesUploaded}
                                        onClick={(e) => handleDownload(e)}
                                        downloadable={clickable}
                                        disable={disable || fileUpload.disable}
                                        completionHash={completionHash}
                                        getFilesChanged={props.getFilesChanged}
                                        detailPage={detailPage}
                                        showIcon={detailPage}
                                        getFiles={getFiles}
                                        disableDelete={disableDelete}
                                    />
                                );
                            })}
                        </List>
                    </Box>
                )}
                {!disable &&
                    (detailPage &&
                        <Box sx={uploadBoxStyle} {...getRootProps({
                            onClick: event => {
                                if (disable) event.stopPropagation();
                            }
                        })}>
                            <input {...getInputProps()} />
                            <IconContext.Provider value={{ size: clickable || isStep5 ? "2rem" : "10rem" }}>
                                <MdCloudUpload />
                            </IconContext.Provider>
                            <Box>{textUpload}</Box>
                        </Box>
                    )
                }
            </Box>
        </Box>
    );
};

export default FileUpload;
